module.exports = {["template-constructor-helpers-typekit-popup"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="typekit-popup">\n		<div class="full-house">Full House</div>\n		<div class="error-message">Sadly, but you cannot store more than 5 of Typekit’s fonts in your font selector. Please remove one and try again.</div>\n\n		<div class="corner-wrapper">\n			<div class="corner"></div>\n		</div>\n	</div>\n\n';
}
return __p;
},}